import styled from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';

type Props = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const StyledTD = styled.td<Props>`
    padding: 10px ${({ theme }) => theme.space[4]};

    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}
`;
